/**
 * LabelValue model, utilized by every collection whose fetch method returns an array of LabelValueBeans
 * @class
 */
import Base from '@netx/core/lib/netx-model';

class LabelValue extends Base {
	/**
	 * Set the attribute backbone will look to as the id
	 * @type {string}
	 */
	get idAttribute() {
		return 'label';
	}
	/**
	 * @property {object}  defaults        - The default attribute values
	 * @property {string}  defaults.label  - The default label
	 * @property {string}  defaults.value  - The default value
	 */
	get defaults() {
		return {
			label: undefined,
			value: undefined,
		};
	}

	/** @type {string} */
	static get __name__() {
		return 'LabelValue';
	}
}

export default LabelValue;
